// extracted by mini-css-extract-plugin
module.exports = {"errorIdWrapper":"style_errorIdWrapper__rUThL"};